/* eslint-disable */
// #### Example usage:
//      {{#condition "<value1> <operator> <value2>"}}
//          <content>
//      [ {{else}} <else content> ]
//      {{/condition}}
//
//  Assumptions: operators are separated by spaces
//      (x === '1' || x === '2') is not supported
//      use
//      (x === '1') || (x === '2')
//      ($scope.key === 'value') - (NOTE: no quotes around $scope.key) $scope.key will pull the
//       value of key from the scope using Utils.get("scope.key", options)
//      Multiple expressions are allowed, just need to separate each within parenthesis:
//      a === true && b === 'abc' || c === 'def' && d === false is not supported
//      (a === true) && ((b === 'abc') || ((c === 'def') && (d === false))) is supported
//      flagA && (flagB || (flagC && flagD)) is supported. (Same as above but easier to read :D )
//      Outer parenthesis are NOT supported
//      (flagA && flagB) is not supported
//      flagA && flagB is supported
//  Usable values:
//      Handlebars variables with @ - Example: @index, @key, @first, @last
//      this - Handlebars current context
//      Scope variables created with set helper - Example $scope.key
//  Available operators
//      || - Logical OR
//      && - Logical AND
//      ===, !== - Identity comparison(no type conversion)
//      ==, != - Equality comparison(type conversion)
//      <, >, <=, >= - Relational comparison
//      %, +, -, *, / - Mathematical operations

function quickBagConditionHelper (expression, options) {
  const scopes = {
    defaultScope: {},
  };

  function getContextValue(exp, context, options) {
    context = context || {};
    options = options || {};

    if (exp.indexOf('.') === -1) {
      // private variable
      if (exp.indexOf('@') === 0) {
        return options.data ? options.data[exp.substr(1)] : undefined;
      }
      // keyword 'this'
      else if (exp === 'this') {
        return context;
      }
      // [x] => x
      exp = exp.replace(/^\[(.+)\]$/, '$1').trim();
      return context[exp];
    }
    let parts = exp.split('.'),
      i = 0,
      l = parts.length,
      retValue = context;
    for (; i < l; i++) {
      retValue = getContextValue(parts[i], retValue);

      if (!retValue) {
        break;
      }
    }

    return retValue;
  }

  function get(key, options) {
    if (!key) {
      return undefined;
    }

    options = options || {};

    let data = options.data || {},
      parts,
      scope;

    if (key.indexOf('.') !== -1) {
      parts = key.split('.');
      scope = scopes[parts[0]];

      return scope ? scope[parts[1]] : undefined;
    }

    return data.templateScope ? data.templateScope[key] : scopes.defaultScope[key];
  }


  // Assumption str will pass isPrimitive test
  function getPrimitiveValue(str) {
    if (/^(['"]).*\1$/.test(str)) {
      // convert '0' => String 0
      str = str.replace(/^(['"])(.*)\1$/, '$2');
    } else {
      // 0 => Number(0)
      str = Number(str);
    }

    return str;
  }

  function parse(str, sections, strings) {
    sections = sections || [];
    strings = strings || [];

    // skip corresponding \' and \"
    let stringRegex = /(?:'(?:[^'\\]|\\\')*')|(?:"(?:[^"\\]|\\\")*")/,
      sectionRegex = /\([^\)\(]*\)/,
      match,
      parts,
      tree = {},
      refill = function (text) {
        text = text
          .replace(/---(\d+)---/, (m, p1) => sections[p1])
          .replace(/%%%(\d+)%%%/g, (m, p1) => strings[p1]);
        return text;
      };

    str = str.trim();
    // change " ( a < b ) " to "a < b"
    if (str.match(/^\([^)(]+\)$/)) {
      str = str.replace(/^\((.*)\)$/, '$1').trim();
    }

    while ((match = stringRegex.exec(str)) !== null) {
      str = str.replace(stringRegex, (`%%%${strings.length}%%%`));
      strings.push(match[0]);
    }

    // strings have been replaced, so no confusion of '(' or ')' inside strings
    while ((match = sectionRegex.exec(str)) !== null) {
      str = str.replace(sectionRegex, (`---${sections.length}---`));
      sections.push(match[0]);
    }

    parts = str.split(/\s+/);
    if (parts.length !== 1 && parts.length !== 3) {
      throw `invalid number of arguments ${parts}`;
    }

    // TODO: can we refill what ever is necessary NOT every thing
    tree.arg1 = refill(parts[0]);
    if (parts.length > 1) {
      // Need the previous sections, so pass the previous sections to parse
      tree.arg1 = parse(tree.arg1, sections, strings);
      tree.operator = parts[1];

      // Need the previous sections, so pass the previous sections to parse
      tree.arg2 = parse(refill(parts[2]), sections, strings);
    }

    return tree;
  }

  function calculate(arg1, operator, arg2) {
    /* jshint eqeqeq: false */
    // in handlebars {{this}} could be a Number or String, so we need to provide == and !=

    switch (operator) {
      case '||':
        return arg1 || arg2;
      case '&&':
        return arg1 && arg2;
      case '==':
        return arg1 == arg2;
      case '===':
        return arg1 === arg2;
      case '!=':
        return arg1 != arg2;
      case '!==':
        return arg1 !== arg2;
      case '<':
        return arg1 < arg2;
      case '<=':
        return arg1 <= arg2;
      case '>':
        return arg1 > arg2;
      case '>=':
        return arg1 >= arg2;
      case '%':
        return arg1 % arg2;
      case '+':
        return arg1 + arg2;
      case '-':
        return arg1 - arg2;
      case '/':
        return arg1 / arg2;
      case '*':
        return arg1 * arg2;
      default:
        throw `Operator '${operator}' is not implemented.`;
    }
  }


  function isPrimitive(val) {
    let retValue;

    if (isNaN(Number(val))) {
      // Not a Number, check for pattern like "something"
      retValue = /^(['"]).*\1$/.test(val);
    } else {
      // Number
      retValue = true;
    }

    return retValue;
  }

  function processTree(tree, context, options) {
    let arg1,
      arg2,
      operator = tree.operator,
      exp;

    if (!operator) {
      exp = tree.arg1;

      switch (exp) {
        case 'true':
        case true:
          return true;

        case 'false':
        case false:
          return false;

        case 'undefined':
        case undefined:
          return undefined;

        case 'null':
        case null:
          return null;

        default:
          // exp will always be of type string
          // either 'str' or 10 or x.y.[5] etc.
          // in above example 'str' and 10 will be considered primitive, string and number respectively
          if (isPrimitive(exp)) {
            return getPrimitiveValue(exp);
          }
          // Assume $test is a variable that was saved with {{set}} helper
          else if (typeof exp === 'string' && exp.indexOf('$') === 0) {
            return get(exp.substr(1), options);
          }
          return getContextValue(exp, context, options);
      }
    }

    arg1 = processTree(tree.arg1, context, options);
    arg2 = processTree(tree.arg2, context, options);

    // TODO: work on short circuit
    return calculate(arg1, operator, arg2);
  }

  function isFunction(value) {
    return typeof value === 'function';
  }

  function isEmpty(value) {
    if (!value && value !== 0) {
      return true;
    } else if (Array.isArray(value) && value.length === 0) {
      return true;
    }
    return false;
  }

  function handlebarsIF(conditional, options) {
    if (isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    if ((!options.hash.includeZero && !conditional) || isEmpty(conditional)) {
      return options.inverse(this);
    }
    return options.fn(this);
  }

  // Utility method
  function callOtherHelper(helper, args) {
    if (!helper) {
      throw `Helper '${helper}' not found.`;
    }

    return helper.apply(this, args);
  }

  /*
   * Expose inner methods for unit test
   */
    if(expression === 'set-helper-unit-test'){
        return quickBagConditionHelper.utilities = {
            getContextValue,
            get,
            getPrimitiveValue,
            parse,
            calculate,
            isPrimitive,
            processTree,
            isFunction,
            isEmpty,
            handlebarsIF,
            callOtherHelper
        };
    }
  /*
   * Main Function
   */
    return callOtherHelper.call(this, handlebarsIF, [
      processTree(parse(expression), this, options),
      options,
    ]);
}

module.exports = quickBagConditionHelper;